module.exports = "/static/fonts/Framework7Icons-Regular.1e81c20.woff";


//////////////////
// WEBPACK FOOTER
// ./~/framework7-icons/fonts/Framework7Icons-Regular.woff
// module id = 1132
// module chunks = 2